<app-organizer-shared-form-wrapper
  class="organizer-activity-planning-page-activity"
  [sectionTitle]="'activity_planning.activity.layout.title' | translate"
  [formGroup]="formGroup"
  [tipsConfig]="tipsConfig"
  [error$]="error$"
  [watchTipsChanges]="true"
  [hasPreviousButton]="false"
  (formSubmit)="submit()"
>
  <app-activity-card
    class="organizer-activity-planning-page-activity__activity-card"
    [picture]="picture"
    [title]="activity?.name"
    [address]="activity?.fullAddress"
    [duration]="activity?.formattedDuration(dateLocale)"
    [isLive]="activity?.isLive"
    [maxPrice]="activityOfferMaxPrice"
    [currency]="activity?.minPriceOffer?.currency"
    [visibility]="activity?.visibility"
  ></app-activity-card>

  <ng-container
    formArrayName="dateSelections"
    *ngFor="
      let dateSelectionGroup of dateSelectionControls;
      let dateSelectionIndex = index
    "
  >
    <ng-container [formGroupName]="dateSelectionIndex">
      <app-form-input-group
        class="organizer-activity-planning-page-activity__date-selection"
        [errors]="getErrors(dateSelectionGroup.get('dateSelection'))"
        [errorKey]="'dateSelection'"
      >
        <app-organizer-activity-planning-date-selection
          #content
          formControlName="dateSelection"
          [defaultValue]="dateSelectionGroup.value"
          [isLive]="activity?.isLive"
          [location]="activity?.location?.geo"
          [showRecurrentSection]="!activity?.isCourse && !activity?.isEvent"
          (deleteCard)="deleteCard(dateSelectionIndex)"
        ></app-organizer-activity-planning-date-selection>
      </app-form-input-group>
    </ng-container>
  </ng-container>

  <button
    class="mt-6"
    app-vtmn-play-button
    type="button"
    [type]="ctaButtonType.Button"
    [variant]="vtmnPlayButtonVariant.PRIMARY"
    (click)="addDateSelection()"
  >
    {{ 'activity_planning.activity.buttons.add_timeslot' | translate }}
  </button>

  <div class="mt-2" *ngIf="formattedDateArrayErrors?.length" aria-live="polite">
    <p
      class="flex items-center text-xs text-danger"
      *ngFor="let error of formattedDateArrayErrors"
    >
      <vtmn-play-icon
        class="mr-1 text-sm"
        [name]="iconTypeEnum.WarningError"
      ></vtmn-play-icon>
      <span>{{ error }}</span>
    </p>
  </div>

  <app-modal
    #timeslotsLimitReachedModal
    [role]="modalRole.AlertDialog"
    [hasCloseButton]="false"
    [modalVariant]="modalVariant.Secondary"
    (modalClose)="timeslotsLimitReachedModal.hide()"
  >
    <span modal-header>
      {{ 'activity_planning.activity.timeslots_limit_modal.title' | translate }}
    </span>

    <p modal-content>
      {{ timeslotsLimitModalText }}
    </p>

    <div modal-footer class="flex justify-end">
      <button
        app-vtmn-play-button
        type="button"
        [type]="ctaButtonType.Button"
        class="ml-3"
        [variant]="vtmnPlayButtonVariant.PRIMARY"
        [shape]="vtmnPlayButtonShape.SQUARED"
        (click)="timeslotsLimitReachedModal.hide()"
      >
        {{
          'activity_planning.activity.timeslots_limit_modal.confirm_button'
            | translate
        }}
      </button>
    </div>
  </app-modal>
</app-organizer-shared-form-wrapper>
